import React, { forwardRef, useCallback } from 'react';

// INTERFACE
import { IRadio } from '../../interfaces/Radio.interface';

// STYLES
import { Container, RadioStyled, Span } from './styles';

// UTILS
import { renderHtml } from '../../utils/html';

const Radio: React.FC<IRadio> = forwardRef(
  ({ checked, disabled = false, label, name, onChange, value }: IRadio, ref: React.Ref<HTMLButtonElement>) => {
    const handleChange = useCallback(
      (e) => {
        if (!e.target.disabled && typeof onChange === 'function') {
          onChange(e);
        }
      },
      [onChange]
    );

    return (
      <Container disabled={disabled}>
        <RadioStyled
          defaultChecked={checked}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          ref={ref}
          type="radio"
          value={value}
        />
        <Span {...renderHtml(label)} />
      </Container>
    );
  }
);

export default Radio;
